import React from "react"

import styles from "./pseudoButton.module.scss"

const PseudoButton = props => {
  return (
    <div className={styles.button}>
      <span>{props.label}</span>
    </div>
  )
}

export default PseudoButton
